export function env() {
    return {
        //@ts-ignore
        REACT_APP_CALL_HUB_URL: window.communicationConfig && window.communicationConfig['REACT_APP_CALL_HUB_URL'] ? window.communicationConfig['REACT_APP_CALL_HUB_URL']
            : process.env.REACT_APP_CALL_HUB_URL,
        //@ts-ignore
        REACT_APP_CHAT_HUB_URL: window.communicationConfig && window.communicationConfig['REACT_APP_CHAT_HUB_URL'] ? window.communicationConfig['REACT_APP_CHAT_HUB_URL']
            : process.env.REACT_APP_CHAT_HUB_URL,
        //@ts-ignore
        REACT_APP_ONLINE_HUB_URL: window.communicationConfig && window.communicationConfig['REACT_APP_ONLINE_HUB_URL'] ? window.communicationConfig['REACT_APP_ONLINE_HUB_URL']
            : process.env.REACT_APP_ONLINE_HUB_URL,
        //@ts-ignore
        REACT_APP_BACKEND_URL: window.communicationConfig && window.communicationConfig['REACT_APP_BACKEND_URL'] ? window.communicationConfig['REACT_APP_BACKEND_URL']
            : process.env.REACT_APP_BACKEND_URL,
        //@ts-ignore
        REACT_APP_REGISTER_URL: window.communicationConfig && window.communicationConfig['REACT_APP_REGISTER_URL'] ? window.communicationConfig['REACT_APP_REGISTER_URL']
            : process.env.REACT_APP_REGISTER_URL,
        //@ts-ignore
        REACT_APP_USE_TM_AUTH: (window.communicationConfig && window.communicationConfig['REACT_APP_USE_TM_AUTH'] ? window.communicationConfig['REACT_APP_USE_TM_AUTH']
            : process.env.REACT_APP_USE_TM_AUTH) === "true",
        //@ts-ignore
        REACT_APP_ROOT_FOLDER: window.communicationConfig && window.communicationConfig['REACT_APP_ROOT_FOLDER'] ? window.communicationConfig['REACT_APP_ROOT_FOLDER']
            : process.env.REACT_APP_ROOT_FOLDER,
        //@ts-ignore
        REACT_APP_WAIT_ADMIN_MESSAGE: window.communicationConfig && window.communicationConfig['REACT_APP_WAIT_ADMIN_MESSAGE'] ? window.communicationConfig['REACT_APP_WAIT_ADMIN_MESSAGE']
            : process.env.REACT_APP_WAIT_ADMIN_MESSAGE,
        //@ts-ignore
        REACT_APP_STUNS_LIST: window.communicationConfig && window.communicationConfig['REACT_APP_STUNS_LIST'] ? window.communicationConfig['REACT_APP_STUNS_LIST']
            : process.env.REACT_APP_STUNS_LIST,
        //@ts-ignore
        REACT_APP_ENABLE_WHITE_BOARD: (window.communicationConfig && window.communicationConfig['REACT_APP_ENABLE_WHITE_BOARD'] ? window.communicationConfig['REACT_APP_ENABLE_WHITE_BOARD']
            : process.env.REACT_APP_ENABLE_WHITE_BOARD) === "true",
        //@ts-ignore
        REACT_APP_SHOW_VIDEOCHAT_LINK: (window.communicationConfig && window.communicationConfig['REACT_APP_SHOW_VIDEOCHAT_LINK'] ? window.communicationConfig['REACT_APP_SHOW_VIDEOCHAT_LINK']
            : process.env.REACT_APP_SHOW_VIDEOCHAT_LINK) === "true",
        //@ts-ignore
        REACT_APP_SERVICE_TYPE: window.communicationConfig && window.communicationConfig['REACT_APP_SERVICE_TYPE'] ? window.communicationConfig['REACT_APP_SERVICE_TYPE']
            : process.env.REACT_APP_SERVICE_TYPE,
        //@ts-ignore
        REACT_APP_CHAT_FILE_TYPES: window.communicationConfig && window.communicationConfig['REACT_APP_CHAT_FILE_TYPES'] ? window.communicationConfig['REACT_APP_CHAT_FILE_TYPES']
            : process.env.REACT_APP_CHAT_FILE_TYPES,
        //@ts-ignore
        REACT_APP_CHAT_SEND_DISABLED_MESSAGE: window.communicationConfig && window.communicationConfig['REACT_APP_CHAT_SEND_DISABLED_MESSAGE'] ? window.communicationConfig['REACT_APP_CHAT_SEND_DISABLED_MESSAGE']
            : process.env.REACT_APP_CHAT_SEND_DISABLED_MESSAGE,
        //@ts-ignore
        REACT_APP_FULL_CHAT: (window.communicationConfig && window.communicationConfig['REACT_APP_FULL_CHAT'] ? window.communicationConfig['REACT_APP_FULL_CHAT']
                : process.env.REACT_APP_FULL_CHAT) === "true",
        //@ts-ignore
        REACT_APP_CHAT_WIDTH: window.communicationConfig && window.communicationConfig['REACT_APP_CHAT_WIDTH'] ? window.communicationConfig['REACT_APP_CHAT_WIDTH']
            : process.env.REACT_APP_CHAT_WIDTH,
        //@ts-ignore
        REACT_APP_CONTEXT_URL: window.communicationConfig && window.communicationConfig['REACT_APP_CONTEXT_URL'] ? window.communicationConfig['REACT_APP_CONTEXT_URL']
            : process.env.REACT_APP_CONTEXT_URL,

        //@ts-ignore
        REACT_APP_MAIN_COLOR: window.communicationConfig && window.communicationConfig['REACT_APP_MAIN_COLOR'] ? window.communicationConfig['REACT_APP_MAIN_COLOR']
            : process.env.REACT_APP_MAIN_COLOR,
            
        //@ts-ignore
        REACT_APP_CHAT_BACKGROUND: window.communicationConfig && window.communicationConfig['REACT_APP_CHAT_BACKGROUND'] ? window.communicationConfig['REACT_APP_CHAT_BACKGROUND']
            : process.env.REACT_APP_CHAT_BACKGROUND,

        //@ts-ignore
        REACT_APP_CHANGE_ACCESS: (window.communicationConfig && window.communicationConfig['REACT_APP_CHANGE_ACCESS'] ? window.communicationConfig['REACT_APP_CHANGE_ACCESS']
            : process.env.REACT_APP_CHANGE_ACCESS) === "true"
    };
}